<!-- 版房控制台 -->
<template>
    <div>
        <!-- 搜索栏 -->
        <order-search
                :count-data="countTagData"
                :search-url="searchUrl"
                :handle-success="handleSearchResponse"
                :handle-re-fresh="handleRefreshResponse"
                :refresh-url="defaultUrl">
            <el-col :span="1">
                <i v-show="loading" class="el-icon-loading"></i>
            </el-col>
            <el-col class="row-tags" :span="2">
                <div>
                    <el-tag type="info" size="small">订单数量:{{ orders.length }} / {{ count }}</el-tag>
                </div>
            </el-col>

        </order-search>

        <!-- 内容列表 -->
        <order-table :sort-url="defaultUrl" @handlesort="handleRefreshResponse" :click-modify="clockModify"
                     :showModify="true" :orders="orders"/>

        <!-- 下一页 -->
        <next-foo :next-url="nextUrl" :handle-response="handleResponse"/>

        <!-- 编辑页面 -->
        <order-stereo-modify ref="orderModify"/>
    </div>
</template>

<script>
    import OrderTable from "../components/orders/OrderTable"
    import OrderSearch from "../components/orders/OrderSearch"
    import NextFoo from "../components/NextFoo"
    import OrderStereoModify from "../components/orders/OrderStereoModify"
    import {mapGetters, mapMutations} from 'vuex'

    export default {
        name: "OrderStereo",
        data() {
            const rootUrl = `${this.$const.orderListUrl}?ordering=id`

            return {
                // 加载/刷新初始数据的接口地址
                // 版房未完成的数据
                defaultUrl: `${rootUrl}&stereoinfo__finish=false`,

                // 在版房控制台搜索的数据
                // 只能搜索已经审核通过的数据 并且是生产订单
                searchUrl: `${this.$const.orderListUrl}?verifyorder__result=PASS&kind=FACTORY`,

                // 下一页的加载接口地址
                nextUrl: '',

                // 订单数据
                count: 0,

                // 是否加载数据
                loading: false,

                // 快捷标签的配置数据
                countTagData: {
                    countTagsUrl: `${this.$const.orderListUrl}stereo_counts/`,
                    dataArr: [
                        {
                            tagName: '已完成: ',
                            count: 0,
                            loading: false,
                            url: `${rootUrl}&stereoinfo__finish=true`,
                            countKey: 'finished',
                            type: 'success'
                        },
                        {
                            tagName: '待处理: ',
                            count: 0,
                            loading: false,
                            url: `${rootUrl}&stereoinfo__finish=false`,
                            countKey: 'un_finish',
                            type: 'danger'
                        },
                        {
                            tagName: '加急: ',
                            count: 0,
                            loading: false,
                            url: `${rootUrl}&stereoinfo__finish=false&urgent=true`,
                            countKey: 'urgent',
                            type: 'danger'
                        },
                    ],
                },

            }
        },
        computed: {
            /**
             * 所有的工艺模版信息
             */
            craftProcessArray() {
                return this.CraftProcessData['CraftProcessArray']
            },

            /**
             * 编辑组件
             */
            orderModifyCom() {
                return this.$refs.orderModify
            },

            /**
             * 待版房处理的订单
             * 从 stereoOrderData 中提取订单数组
             */
            orders() {
                return this.stereoOrderData['orderList']
            },

            /**
             * 将 store 的待版房处理的订单映射到组件中
             */
            ...mapGetters(['stereoOrderData', 'CraftProcessData'])
        },
        methods: {

            /**
             * 点击编辑按钮的事件
             */
            clockModify(row) {
                // 打开编辑对话框
                this.orderModifyCom.open()

                // 设置订单的订单为当前正在处理的订单
                this.setCurrentStereoOrder(row)
            },

            /**
             * 加载初始的订单内容
             * stereoOrderData 初始为空，这里进行加载填充初始数据
             */
            loadOrders() {
                if (this.orders.length <= 0) {
                    this.loading = true
                    this.$getRequest(this.defaultUrl)
                        .then(response => {
                            this.loading = false
                            this.handleResponse(response)
                        })
                        .catch(error => {
                            this.loading = false
                        })
                }

            },

            /**
             * 加载工艺流程模版
             */
            loadCraftProcesses() {
                if (this.craftProcessArray.length <= 0) {
                    const url = this.$const.craftProcessUrl
                    this.$getRequest(url)
                        .then(response => {
                            this.addCraftProcesses(response.data)
                        })
                        .catch(error => {
                            this.$message({
                                type: 'error',
                                showClose: true,
                                message: '加载工艺模版选项失败'
                            })
                        })
                }
            },

            /**
             * 处理搜索的响应结果
             */
            handleSearchResponse(response) {
                this.handleResponse(response, 'set')
            },

            /**
             * 处理刷新的响应结果
             */
            handleRefreshResponse(response) {
                this.handleResponse(response, 'set')
            },

            /**
             * 处理响应信息
             */
            handleResponse(response, mod = 'add') {
                let handler = null
                if (mod === 'add') {
                    handler = this.addStereoOrders
                } else if (mod === 'set') {
                    handler = this.setStereoOrders
                } else {
                    console.log('mod must be in `add` or `set`')
                    return
                }

                // 解构响应数据
                const {count, results, next} = response.data
                this.nextUrl = this.$utils.handleOrderUrl(next)
                this.count = count
                handler(results)
            },

            /**
             * 将 Vuex 中的 mutations 映射成组件中的方法
             */
            ...mapMutations([
                'addStereoOrders',          // 添加(版房)多个订单
                'setStereoOrders',          // 设置(版房)多个订单
                'setCurrentStereoOrder',    // 设置(版房)当前正在处理的订单
                'addCraftProcesses',
            ])
        },
        components: {
            OrderStereoModify,
            NextFoo,
            OrderSearch,
            OrderTable,
        },
        created() {
            this.loadOrders()
            this.loadCraftProcesses()
        },
    }
</script>

<style scoped>
    .row-tags div {
        float: left;
        margin: 0 4px;
    }
</style>